// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AppsFlyerDeepLinkFetchCompleteEvent
 */
export var AppsFlyerDeepLinkFetchComplete = function (_a) {
    var resultStatus = _a.resultStatus, errorType = _a.errorType, networkStatus = _a.networkStatus, millisLapsedAfterInitialization = _a.millisLapsedAfterInitialization;
    return ({
        name: "AppsFlyerDeepLink Fetch Complete",
        parameters: {
            cdf_entity: "AppsFlyerDeepLink",
            cdf_action: "Fetch",
            result_status: resultStatus !== undefined && resultStatus !== null ? resultStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_status: networkStatus !== undefined && networkStatus !== null ? networkStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            millis_lapsed_after_initialization: millisLapsedAfterInitialization !== undefined && millisLapsedAfterInitialization !== null ? millisLapsedAfterInitialization.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
